import { SIM_DT } from '../config';

export interface MatchFlowDefinition {
  readonly goalCelebrationSeconds: number;
  readonly goalReplayMaximumSeconds: number;
  readonly kickoffCountdownSeconds: number;
  readonly kickoffGoCueSeconds: number;
  readonly durationSeconds?: number | null;
  readonly startsInPreparation?: boolean;
}

const GOAL_CELEBRATION_SECONDS = 3.5;
// Safety ceiling only; GoalReplaySystem normally ends playback much earlier.
// Keep this above the retained replay history so delayed shots are never cut off by match flow.
const GOAL_REPLAY_MAXIMUM_SECONDS = 60;

const EXHIBITION_MATCH_FLOW: MatchFlowDefinition = Object.freeze({
  goalCelebrationSeconds: GOAL_CELEBRATION_SECONDS,
  goalReplayMaximumSeconds: GOAL_REPLAY_MAXIMUM_SECONDS,
  kickoffCountdownSeconds: 3,
  kickoffGoCueSeconds: 0.75,
});

const FREEPLAY_MATCH_FLOW: MatchFlowDefinition = Object.freeze({
  goalCelebrationSeconds: GOAL_CELEBRATION_SECONDS,
  goalReplayMaximumSeconds: GOAL_REPLAY_MAXIMUM_SECONDS,
  kickoffCountdownSeconds: 0,
  kickoffGoCueSeconds: 0,
});

export function exhibitionMatchFlow(): MatchFlowDefinition {
  return EXHIBITION_MATCH_FLOW;
}

export function freeplayMatchFlow(): MatchFlowDefinition {
  return FREEPLAY_MATCH_FLOW;
}

export function validateMatchFlowDefinition(definition: MatchFlowDefinition): void {
  positive(definition.goalCelebrationSeconds, 'goal celebration duration');
  nonNegative(definition.goalReplayMaximumSeconds, 'goal replay maximum duration');
  nonNegative(definition.kickoffCountdownSeconds, 'kickoff countdown duration');
  nonNegative(definition.kickoffGoCueSeconds, 'kickoff GO cue duration');
  if (definition.durationSeconds !== undefined && definition.durationSeconds !== null) {
    positive(definition.durationSeconds, 'match duration');
    if (!Number.isSafeInteger(Math.ceil(definition.durationSeconds / SIM_DT))) {
      throw new Error('Match duration exceeds the supported simulation tick range.');
    }
  }
}

function positive(value: number, label: string): void {
  if (!Number.isFinite(value) || value <= 0) throw new Error(`${label} must be a positive finite number.`);
}

function nonNegative(value: number, label: string): void {
  if (!Number.isFinite(value) || value < 0) throw new Error(`${label} must be a non-negative finite number.`);
}
